import React from 'react'

import {Flex} from '/app/src/component'
import FeatureItem from './FeatureItem'

const featuresStyle = {

}

const featureListStyle = {

}

const StartFeatures = () => {
    const color = 'JibberBlue_M'
    return (
        <Flex column {...featuresStyle}>
            <Flex {...featureListStyle}>
                <FeatureItem
                featureName='Skräddarsy'
                color={color}
                imgSrc='/images/Menu_ClientChat_L.svg'/>
                <FeatureItem
                featureName='Live statistik'
                color={color}
                imgSrc='/images/Menu_Overview_L.svg'/>
                <FeatureItem
                featureName='Automeddelande'
                color={color}
                imgSrc='/images/Menu_ClientChatAutomessage_L.svg'/>
            </Flex>
            <Flex {...featureListStyle}>
                <FeatureItem
                featureName='Snabbsvar'
                color={color}
                imgSrc='/images/Menu_ChatsettingsQuickResponse.svg'/>
                <FeatureItem
                featureName='Frågor & svar'
                color={color}
                imgSrc='/images/Menu_ClientChatFAQ_L.svg'/>
                <FeatureItem
                featureName='Offlineinställningar'
                color={color}
                imgSrc='/images/Menu_ClientChatShowHide_L.svg'/>
            </Flex>
        </Flex>
    )
}

export default StartFeatures



// WEBPACK FOOTER //
// ./src/component/Modal/WelcomeModal/StartFeatures.js